/**
 * @Description: 获取设置客户信息
 */


/**
 * 
 * @export
 * @param {*} 
 *
 */
export function getCustomer(){
  let promise = new Promise((resolve, reject) => {
    let U_info = sessionStorage.getItem('customerInfos')
    if(U_info) {
      resolve(JSON.parse(unescape(U_info))) 
    } else {
    // 如果接口延时就重新等待调取信息
      let time = 1
      let loopGet = setInterval(()=>{
        time ++ 
        U_info = sessionStorage.getItem('customerInfos')
        // 最多5s 读取不到就算了
        if(U_info && time<= 5) {
          clearInterval(loopGet)
          resolve(JSON.parse(U_info)) 
        } else {
          clearInterval(loopGet)
          reject(false) 
        }
      },1000)
    }
  })
  return promise
}

export function setCustomer(val){
  let setVal =  JSON.stringify(val)
  sessionStorage.setItem('customerInfos',setVal)
}





// WEBPACK FOOTER //
// ./src/utils/getCustomer.js